import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getContactData } from '../../../Public/contact-data.js';
import ContactService from '../../../Services/ContactService.js';

// Custom Components
import { ButtonPrimary, ButtonSecondary } from '../../Buttons/button-component.js';
import { InputComponent } from '../../Inputs/input-component.js';

const ContactFormLightweight = ({ onSuccess }) => {
    // 1. Global State
    const { language = 'he', dir } = useSelector((state) => state.systemData || {});

    // 2. Data Source
    const data = getContactData(language);
    const txt = data.lightweightForm;

    // 3. Local State
    const [formData, setFormData] = useState({
        email: '',
        fullName: '',
        phone: ''
    });
    const [status, setStatus] = useState('idle');

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.email && !formData.phone) {
            alert(txt.errorMsg);
            return;
        }

        setStatus('loading');

        const { email, fullName, phone } = formData;

        try {
            // Contact (under the account) + email are both handled by sendContact → /public/contact
            await ContactService.sendContact({
                fullName, email, phone,
                subject: 'Quick Lead from Website',
                message: 'Lightweight form submission',
                leadSource: txt.leadSource
            });

            setStatus('success');
            if (onSuccess) onSuccess();

            setFormData({ email: '', fullName: '', phone: '' });
            setTimeout(() => setStatus('idle'), 2000);

        } catch (error) {
            setStatus('idle');
        }
    };

    return (
        <form dir={dir} className="w-full flex flex-col gap-4" onSubmit={handleSubmit}>
            <h3 className="text-xl font-bold mb-1 hidden">{txt.title}</h3>

            <InputComponent
                size="lg"
                placeholder={txt.placeholders.name}
                value={formData.fullName}
                onChange={(e) => handleChange('fullName', e.target.value)}
                required
                className="bg-white/80 backdrop-blur-sm"
            />

            <InputComponent
                size="lg"
                type="tel"
                placeholder={txt.placeholders.phone}
                value={formData.phone}
                onChange={(e) => handleChange('phone', e.target.value)}
                className="bg-white/80 backdrop-blur-sm"
            />

            <InputComponent
                size="lg"
                type="email"
                dir="ltr"
                className={`bg-white/80 backdrop-blur-sm ${dir === 'rtl' ? 'text-right' : 'text-left'}`}
                placeholder={txt.placeholders.email}
                value={formData.email}
                onChange={(e) => handleChange('email', e.target.value)}
            />

            <ButtonSecondary
                type="submit"
                fullWidth
                size="lg"
                className="shadow-md mt-2 flex justify-center items-center gap-2"
                disabled={status === 'loading'}
            >
                <span>{status === 'loading' ? txt.sendingLabel : txt.submitLabel}</span>
            </ButtonSecondary>
        </form>
    );
};

export default ContactFormLightweight;